import useSWR from "swr";
import { fetcherV2 } from "@gogive/services";
import { routes, TopDonorsResponse } from "@/services/donors.service";

export function useTopDonors(limit = 5) {
  const { data, error, mutate } = useSWR(
    [routes.topDonors, { limit }],
    fetcherV2<TopDonorsResponse>,
    {
      revalidateIfStale: true,
      revalidateOnFocus: true,
      revalidateOnReconnect: true,
      suspense: false,
      shouldRetryOnError: false,
    }
  );

  return {
    topDonors: data?.result ?? [],
    isLoading: !error && !data,
    isError: error,
    refresh: mutate,
  };
}
